import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "*",
        redirect: "error-404",
    },
    {
        path: "/",
        redirect: {
            name: "messaging-inbox",
        },
    },
    {
        path: "/error-404",
        name: "error-404",
        component: () => import("@/views/pages/error/error404.vue"),
        meta: {
            layout: "full",
            resource: "auth",
            action: "read",
        },
    },
    {
        path: "/support",
        name: "support",
        component: () => import("@/views/pages/support.vue"),
    },
    {
        path: "/start-conversation",
        name: "start-conversation",
        component: () => import("@/views/pages/startConversation.vue"),
    },

    // Authentication pages
    {
        path: "/user-blocked",
        name: "user-blocked",
        component: () => import("@/views/pages/authentication/userBlocked.vue"),
        meta: {
            layout: "full",
            resource: "auth",
            action: "read",
        },
    },
    {
        path: "/not-authorized",
        name: "not-authorized",
        // ! Update import path
        component: () => import("@/views/pages/authentication/notAuthorized.vue"),
        meta: {
            layout: "full",
            resource: "auth",
            action: "read",
        },
    },

    {
        path: "/failed-login",
        name: "failed-login",
        component: () => import("@/views/pages/error/failedLogin.vue"),
        meta: {
            layout: "full",
            resource: "auth",
            action: "read",
        },
    },
    {
        path: "/authorize",
        name: "authorize",
        component: () => import("@/views/pages/authentication/authorize.vue"),
        meta: {
            layout: "full",
            resource: "auth",
        },
    },
    {
        path: "/mobile", // @hack just to simulate mobile.saysimple.io locally.
        name: "mobile",
        beforeEnter: isUserLoggedIn,
        meta: {
            layout: "full",
            resource: "auth",
            action: "read",
        },
    },
    {
        path: "/authorize-domain",
        name: "authorize-domain",
        component: () => import("@/views/pages/authentication/authorizeDomain.vue"),
        meta: {
            layout: "full",
            resource: "auth",
            action: "read",
        },
    },
];
